var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 3,
    fill: "#656565",
    stroke: "#848484",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68505 17.2C9.44505 17.2 9.22503 17.12 9.04503 16.94L5.06505 12.96C4.70505 12.6 4.70505 12.04 5.06505 11.68C5.42505 11.32 5.98503 11.32 6.34503 11.68L9.70504 15.02L17.6851 7.06004C18.0451 6.70004 18.6051 6.70004 18.9651 7.06004C19.3251 7.42004 19.3251 7.98004 18.9651 8.34004L10.345 16.94C10.145 17.12 9.92505 17.2 9.68505 17.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxSelected);
export default __webpack_public_path__ + "static/media/check-box-selected.996248474cc59e2486427eaea7bf2cdb.svg";
export { ForwardRef as ReactComponent };